import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import ButtonBase from '@mui/material/ButtonBase'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

export default function ListItem({ primary, secondary, label, arrow, onClick }) {
  return (
    <>
      <ButtonBase
        onClick={onClick}
        sx={{ display: 'flex', alignItems: 'center', width: '100%', p: 2 }}
      >
        <div style={{ flex: 1, textAlign: 'left' }}>
          <Typography variant="body1">
            {primary}
            {label && (
              <Typography
                sx={{
                  ml: 1,
                  border: `1px solid #888`,
                  borderRadius: 2,
                  py: 1,
                  px: 0.5,
                  color: '#888',
                  fontSize: 10,
                }}
                variant="caption"
              >
                {label}
              </Typography>
            )}
          </Typography>
          {secondary && (
            <Typography sx={{ mt: 1 }} variant="caption" component="p">
              {secondary}
            </Typography>
          )}
        </div>
        {arrow && <NavigateNextIcon />}
      </ButtonBase>
      <Divider />
    </>
  )
}
